import moment from "moment";
import axios from "axios";
import iziToast from "izitoast";

import {createStore} from 'vuex'

const LEVEL_XP = 20_000;

const store = createStore({
    state() {
        return {
            collection: {
                cards: []
            },
            user: {
                user_id: null,
                uuid: null,
                loggedIn: false,
                username: null,
                loginAt: null,
                restoreToken: null,
                xp: 0,
                credit: 50,
                isAdmin: false,
                achievements: [],
                rewardsCollected: [],
                notifications: [],
                quests: [],
                statistics: {
                    timesGameHasBeenOpened: 0,
                    earned: 0,
                    spent: 0,
                    cardsDrawn: 0,
                    soldCards: 0,
                    allCardsSold: 0,
                    cardStacksSold: 0,
                    boostersPurchased: 0,
                    boostersOpened: 0,
                    openedAll: 0,
                    skippedOpenings: 0,
                },
            },
            inventory: {
                items: []
            },
            settings: {},
            currentSellSum: 0,
            markers: {
                sellingDuplicates: false,
                selectingCards: false,
                updatingCards: false,
                storingCardsInCollection: false,
            },
            shopInventory: [],
            shopTodaysOffers: [],
            selectedCardForAutoLoadCanvas: null,
        }
    },
    mutations: {
        updateUserData(state, onlyUpdateCredits = false) {
            axios.get('/api/user').then((response) => {
                if (response.status === 200) {
                    state.user.username = response.data.username;
                    state.user.user_id = response.data.id;
                    state.user.uuid = response.data.uuid;
                    state.user.xp = response.data.account.xp;
                    state.user.avatar = response.data.account.avatar;
                    state.user.credit = response.data.account.credit;
                    state.user.statistics = response.data.statistics;
                    state.user.isAdmin = response.data.role_id === 1;
                    state.user.notifications = response.data.notifications;
                    state.user.todays_purchased_booster_count = response.data.todays_purchased_booster_count;
                    state.user.quests = response.data.daily_quests;
                    state.settings = response.data.settings;

                    if (!onlyUpdateCredits) {
                        this.commit('applyTheme');
                        this.commit('achievementCheck');
                        this.commit('updateUserWishlist');
                    }
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.commit('logout')
                }
            })
        },
        updateUserCredits(state) {
            axios.get('/api/user').then((response) => {
                if (response.status === 200) {
                    state.user.credit = response.data.account.credit;
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.commit('logout')
                }
            })
        },
        updateUserInventory(state) {
            axios.get('/api/user/inventory').then((response) => {
                if (response.status === 200) {
                    state.inventory.items = response.data;
                }
            })
        },
        updateUserCards(state) {
            state.markers.updatingCards = true;

            axios.get('/api/user/cards').then((response) => {
                if (response.status === 200) {
                    state.collection.cards = response.data.map(c => {
                        let cardJson = JSON.parse(c.card.json);
                        cardJson.is_in_set_collection = c.is_in_set_collection;
                        cardJson.isSelected = false;
                        cardJson.amount = c.quantity;
                        cardJson.pulled_at = c.last_pulled_at;
                        cardJson.model = c;

                        return cardJson;
                    });

                    state.markers.updatingCards = false;
                }
            })
        },
        loginSuccess(state, responseData) {
            state.user.loggedIn = true;
            state.user.uuid = responseData.user.uuid;
            state.user.restoreToken = responseData.user.restore_token;
            state.user.username = responseData.user.username;
            state.user.loginAt = responseData.login_at;
            state.user.xp = responseData.user.account.xp;
            state.user.credit = responseData.user.account.credit;
            state.user.isAdmin = responseData.user.role_id === 1;
        },
        logout(state) {
            axios.get('/logout').then((response) => {
                state.user.loggedIn = false;
                state.user.uuid = null;
                state.user.restoreToken = null;
                state.user.username = null;
                state.user.loginAt = null;
                state.user.xp = 0;
                state.user.credit = 0;
                window.location.href = 'https://dipocaco.me/';
            })
        },
        sortCollection(state, sortBy = null) {
            if (sortBy === state.settings.sort_by) {
                state.settings.sort_desc = !state.settings.sort_desc;
            }

            state.settings.sort_by = sortBy;

            this.commit('updateSettings', {
                settings: state.settings,
                callback: () => {
                    this.commit('updateUserCards')
                }
            });
        },
        loadAchievements(state) {
            axios.get('/api/user/achievements').then((response) => {
                state.user.achievements = response.data;
            })
        },
        applyTheme(state) {
            // document.body.dataset.bsTheme = state.settings.use_dark_mode ? 'dark' : 'light';
        },
        achievementCheck(state) {
            axios.get('/api/user/check-achievements').then((response) => {
                response.data.forEach(achievement => {
                    iziToast.warning({
                        icon: 'fas fa-trophy',
                        title: achievement.name + "\n",
                        message: achievement.message + (achievement.reward_xp > 0 ? ' <strong>+' + achievement.reward_xp + 'XP!</strong>' : ''),
                        position: 'center',
                        overlay: false,
                        timeout: 4000
                    });
                })

                if (response.data.length > 0) {
                    this.commit('loadAchievements');
                }
            })
        },
        updateSettings(state, params) {
            Object.assign(state.settings, params.settings);

            if (!params.callback) {
                params.callback = () => {};
            }

            axios.post('/api/settings', params.settings).then(params.callback)
        },
        sellCard(state, parameters) {
            axios.post('/api/user/cards/sell', {
                card_id: parameters.card.id,
            }).then(response => {
                iziToast.success({
                    icon: false,
                    message: 'Sold "' + response.data.name + '" for ' + response.data.price + '<img class="notification-icon" src="/assets/dipocaco/currency_x64.png">',
                    position: 'topRight',
                    messageColor: 'black !important',
                });

                this.commit('updateUserData');
                this.commit('updateUserCards');
            }).catch(error => {
                console.log(error);
            });
        },
        sellAllOfOneCard(state, parameters) {
            axios.post('/api/user/cards/sell', {
                card_id: parameters.card.id,
                all: true
            }).then(response => {
                iziToast.success({
                    icon: false,
                    message: 'Sold ' + response.data.quantity + ' of "' + parameters.card.name + '" for ' + response.data.price + '<img class="notification-icon" src="/assets/dipocaco/currency_x64.png">',
                    position: 'topRight',
                    messageColor: 'black !important',
                });

                this.commit('updateUserData');
                this.commit('updateUserCards');
            }).catch(error => {
                console.log(error);
            });
        },
        toggleCardForSale(state, cardId) {
            let cardForSale = state.collection.cards.find(c => c.id === cardId);
            cardForSale.isSelected = !cardForSale.isSelected;
        },
        clearSelectedStatusFromCards(state) {
            state.collection.cards.filter(c => c.isSelected).forEach(c => c.isSelected = false);
        },
        markAllCardsForSale(state, filteredCardCollection) {
            state.collection.cards.filter(c => !c.isSelected).filter(c => filteredCardCollection.includes(c)).forEach(c => c.isSelected = true);
        },
        sellAllDuplicates(state) {
            state.markers.sellingDuplicates = true;

            axios.post('/api/user/cards/duplicates').then(response => {
                iziToast.success({
                    icon: false,
                    message: 'Sold ' + response.data.quantity + ' duplicates for ' + response.data.price + '<img class="notification-icon" src="/assets/dipocaco/currency_x64.png">',
                    position: 'topRight',
                    messageColor: 'black !important',
                });

                this.commit('updateUserData');
                this.commit('updateUserCards');
                state.markers.sellingDuplicates = false;
            }).catch(error => {
                state.markers.sellingDuplicates = false;
            });
        },
        sellSelectedCards(state) {
            state.markers.sellingSelected = true;

            axios.post('/api/user/cards/selection/sell', {
                selection: state.collection.cards.filter(c => c.isSelected === true).map(card => card.id)
            }).then(response => {
                iziToast.success({
                    icon: false,
                    message: 'Sold ' + response.data.quantity + ' cards for ' + response.data.price + '<img class="notification-icon" src="/assets/dipocaco/currency_x64.png">',
                    position: 'topRight',
                    messageColor: 'black !important',
                });

                this.commit('updateUserData');
                this.commit('updateUserCards');
                this.commit('clearSelectedStatusFromCards');
                state.markers.sellingSelected = false;
                state.markers.selectingCards = false;
            }).catch(error => {
                state.markers.sellingSelected = false;
                state.markers.selectingCards = false;
            });
        },
        toggleSelectingCards(state) {
            state.markers.selectingCards = !state.markers.selectingCards;

            if (!state.markers.selectingCards) {
                this.commit('clearSelectedStatusFromCards');
            }
        },
        addSelectedCardsToCollection(state, {selectedCollectionID, moveAll = false, newCollectionName = ''}) {
            state.markers.sellingSelected = true;
            state.markers.selectingCards = true;

            axios.post('/api/user/cards/selection/move-to-collection', {
                selection: state.collection.cards.filter(c => c.isSelected === true).map(card => card.id),
                collectionID: selectedCollectionID,
                moveAll: moveAll,
                newCollectionName: newCollectionName,
            }).then(response => {
                if (response.data.quantity > 0) {
                    iziToast.success({
                        icon: false,
                        message: 'Moved ' + response.data.quantity + ' cards to selected collection',
                        position: 'topRight',
                        messageColor: 'black !important',
                    });
                }

                if (response.data.duplicates > 0) {
                    iziToast.info({
                        icon: false,
                        message: response.data.duplicates+' cards are already stored in your selected collection. You may only add one of each card at the moment.',
                        position: 'topRight',
                        messageColor: 'black !important',
                    });
                }

                this.commit('updateUserData');
                this.commit('updateUserCards');
                this.commit('clearSelectedStatusFromCards');
                state.markers.sellingSelected = false;
                state.markers.selectingCards = false;
            }).catch(error => {
                state.markers.sellingSelected = false;
                state.markers.selectingCards = false;
            });
        },
        addSelectedCardsToMarketplace(state, {priceIncrement = 0}) {
            state.markers.sellingSelected = true;
            state.markers.selectingCards = true;

            axios.post('/api/user/cards/selection/move-to-marketplace', {
                selection: state.collection.cards.filter(c => c.isSelected === true).map(card => card.id),
                priceIncrement: priceIncrement
            }).then(response => {
                if (response.data.quantity > 0) {
                    iziToast.success({
                        icon: false,
                        message: 'Put ' + response.data.quantity + ' cards to the marketplace',
                        position: 'topRight',
                        messageColor: 'black !important',
                    });
                }

                this.commit('updateUserData');
                this.commit('updateUserCards');
                this.commit('clearSelectedStatusFromCards');
                state.markers.sellingSelected = false;
                state.markers.selectingCards = false;
            }).catch(error => {
                state.markers.sellingSelected = false;
                state.markers.selectingCards = false;
            });
        },
        fetchShopItems(state) {
            axios.get('/api/shop/items').then((response) => {
                state.shopInventory = [];
                let seriesList = response.data.regularItems;
                let cooldowns = response.data.cooldowns;
                let regularItemsWithCooldowns = Object.keys(cooldowns['regular_items']);

                Object.keys(seriesList).forEach(currentSeries => {
                    let seriesObject = {
                        name: currentSeries,
                        language: 'en',
                        sets: {},
                    };

                    Object.values(seriesList[currentSeries]).forEach((setItem) => {
                        if (!seriesObject.sets.hasOwnProperty(setItem.set.set_id)) {
                            seriesObject.sets[setItem.set.set_id] = {
                                name: setItem.set.set_name,
                                set_id: setItem.set.set_id,
                                boosterCount: setItem.booster_count,
                                levelRequirement: null,
                                releaseDate: setItem.set.release_date,
                                released: moment().diff(moment(setItem.set.release_date)) > 0,
                                language: setItem.set.language,
                                isComplete: setItem.set.is_complete,
                                items: [],
                            };
                        }

                        if (!seriesObject.sets[setItem.set.set_id].levelRequirement) {
                            seriesObject.sets[setItem.set.set_id].levelRequirement = setItem.level_requirement;
                        }

                        setItem.cooldown_until = cooldowns['regular_items'][setItem.id] ? moment(cooldowns['regular_items'][setItem.id]).add(setItem.cooldown_in_minutes, 'minutes') : null;
                        seriesObject.sets[setItem.set.set_id].items.push(setItem);

                        if (seriesObject.language !== setItem.set.language) {
                            seriesObject.language = setItem.set.language;
                        }
                    });

                    Object.keys(seriesObject.sets).forEach((set) => {
                        seriesObject.sets[set].items.sort((a, b) => a.booster_count - b.booster_count)
                        return set;
                    });

                    state.shopInventory.push(seriesObject);
                });

                // setTimeout(() => {
                //     if ($(window).width() > 1200) {
                //         document.querySelectorAll('.collapse').forEach(collapse => {
                //             collapse.classList.add('show');
                //         })
                //     }
                // }, 100)
            });

            axios.get('/api/shop/todays-offers').then((response) => {
                state.shopTodaysOffers.collections = response.data.collections.map((item) => {
                    item.cooldown_until = response.data.cooldowns[item.id] ? moment(response.data.cooldowns[item.id]).add(item.cooldown_in_minutes, 'minutes') : null;
                    return item;
                });

                state.shopTodaysOffers.blisters = response.data.blisters.map((item) => {
                    item.cooldown_until = response.data.cooldowns[item.id] ? moment(response.data.cooldowns[item.id]).add(item.cooldown_in_minutes, 'minutes') : null;
                    return item;
                });

                state.shopTodaysOffers.tins = response.data.tins.map((item) => {
                    item.cooldown_until = response.data.cooldowns[item.id] ? moment(response.data.cooldowns[item.id]).add(item.cooldown_in_minutes, 'minutes') : null;
                    return item;
                });
            });
        },
        storeNewCardsInCollection(state) {
            state.markers.storingCardsInCollection = true;
            axios.get('/api/collections/store').then(response => {
                state.markers.storingCardsInCollection = false;

                iziToast.success({
                    icon: false,
                    message: 'Stored ' + response.data.quantity + ' cards in your collection',
                    position: 'topRight',
                    messageColor: 'black !important',
                });

                this.commit('updateUserCards')
            });
        },
        updateAutoLoadCanvasCard(state, cardId) {
            state.selectedCardForAutoLoadCanvas = cardId;
        },
        updateUserWishlist(state) {
            axios.get('/api/user/wishlist').then((response) => {
                state.user.wishlist = response.data.map(wC => JSON.parse(wC.card.json));
            })
        },
        toggleWishlist(state, cardId) {
            axios.get('/api/user/wishlist/toggle/'+cardId).then((response) => {
                this.commit('updateUserWishlist');
                iziToast.success({title: response.data.message});
            });
        },
    },
    getters: {
        level(state) {
            return (state.user.xp - (state.user.xp % LEVEL_XP)) / LEVEL_XP + 1;
        },
        toNextLevel(state) {
            return state.user.xp % LEVEL_XP;
        },
        levelXp(state) {
            return LEVEL_XP;
        },
        formattedCredit(state) {
            if (state.user.credit > 1_000_000_000_000) {
                return Math.floor(state.user.credit / 1_000_000_000_000) + ('.' + Math.floor(state.user.credit % 1_000_000_000_000 / 1_000_000_000)) + 'T'
            }

            if (state.user.credit > 1_000_000_000) {
                return Math.floor(state.user.credit / 1_000_000_000) + ('.' + Math.floor(state.user.credit % 1_000_000_000 / 1_000_000)) + 'B'
            }

            if (state.user.credit > 1_000_000) {
                return Math.floor(state.user.credit / 1_000_000) + ('.' + Math.floor(state.user.credit % 1_000_000 / 100_000)) + 'M'
            }

            if (state.user.credit > 10000) {
                return Math.floor(state.user.credit / 1000) + 'K'
            }

            if (state.user.credit > 1000) {
                return Math.floor(state.user.credit / 1000) + ('.' + Math.floor(state.user.credit % 1000 / 100)) + 'K'
            }

            return state.user.credit;
        },
        cardIdsInCollection(state) {
            return state.collection.cards.map(c => c.id);
        },
        cardsForSale(state) {
            return state.collection.cards.filter(c => c.isSelected);
        },
        cardsWithDuplicates(state) {
            return state.collection.cards.filter(c => c.amount > 1);
        },
        fullCardCollectionCount(state) {
            return state.collection.cards.length ? state.collection.cards.map(c => c.amount).reduce((a, b) => a + b) : 0;
        },
        newCardsInCollection(state) {
            return state.collection.cards.filter(c => c.is_in_set_collection === false).length > 0;
        },
        setsInCollection(state) {
            return [...new Set(state.collection.cards.map(card => card.set.id))];
        },
        boosterPurchaseLimitReached(state) {
            return state.user.todays_purchased_booster_count >= 111;
        },
        isWinter(state) {
            return moment().month() === 11;
        },
        isSpookySeason(state) {
            return moment().month() === 9 && moment().day() > 19;
        },
        isSpring(state) {
            return (moment().month() === 4 && moment().day() > 19) || moment().month() === 5;
        },
        isSummer(state) {
            return moment().month() === 6 || moment().month() === 7;
        }
    },
    watch: {
        level(state, newLevel, lastLevel) {
            if (this.loaded && newLevel !== lastLevel && newLevel > lastLevel) {
                iziToast.success({
                    icon: 'fas fa-medal',
                    title: 'Level up!',
                    position: 'topCenter',
                    message: 'Reached level ' + newLevel,
                    timeout: 3000
                });

                window.gameSoundService.play('/assets/dipocaco/sounds/levelup.mp3');
            }
        },
        settings(state, newVal, oldVal) {
            // let theme = 'light';
            //
            // if (state.settings.use_dark_mode) {
            //     theme = 'dark';
            // }
            //
            // document.body.dataset.bsTheme = state.theme;
        }
    }
});

export default store;
